<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchKeyup($event)"
    (onHeaderSearchSubmit)="onSearchSubmit($event)"
  ></page-header-search>

  <div class="row" *ngIf="!modifiedPharmaciesList?.length">
    <div class="col-12 text-center py-5">
      Hmm, There is no Pharmacies to show! 🥳
    </div>
  </div>

  <div class="card" *ngIf="modifiedPharmaciesList && modifiedPharmaciesList?.length">
    <div>
    </div>
    <div [scrollWindow]="false" [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10" infinite-scroll>
      <app-table [list]="modifiedPharmaciesList" [headers]="theadArray" (rowSelected)="routeToPharmacyDetails($event)"></app-table>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
